module.exports = __webpack_public_path__ + "9488d02b/img/upload-icon.9179ae4e.svg";